module.exports = __webpack_public_path__ + "static/media/second_section.e18d1650.svg";